import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { HeaderOptionsComponent } from './header-options.component';
import { HeaderOptionsItemComponent } from './header-options-item/header-options-item.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
  ],
  declarations: [
    HeaderOptionsComponent,
    HeaderOptionsItemComponent,
  ],
  exports: [
    HeaderOptionsComponent,
    HeaderOptionsItemComponent,
  ],
})
export class HeaderOptionsModule {}
